import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { HomePageTextBlock } from 'globals/store/publish.data';
import { DEFAULT_BRANDING_TEXT_SIZE } from '../../helpers/constants';
import { TitleIconComponent } from '../icon/title-icon.component';
import { InputEditorComponent } from '../joi-input/input-editor';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from '../misc/dropdown.component';
import { ColorSelectorComponent } from './color-selector.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';

@Component({
    selector: 'branding-text',
    template: `
<title-icon [titleIcon]="'DESCRIPTION18'" [title]="title"></title-icon>
<input-editor
  [style.--quill-font-size]="(brandingText.fontSize || DEFAULT_FONT_SIZE) + 'px'"
  [style.--quill-font-color]="brandingText.color || '#000000'"
  [object]="brandingText" 
  [prop]="'text'"
  [placeholder]="placeholder"
  (changed)="changed.emit()"
></input-editor>
<div class="extra-choices">
  <div class="choice">
    <h5>Font size and color:</h5> 
    <dropdown 
      [disableDropdown]="false" 
      [selections]="fontSizeSelections" 
      [selected]="fontSizeSelections | findById:(brandingText.fontSize || DEFAULT_FONT_SIZE)" 
      (select)="brandingText.fontSize = $event.id; changed.emit()"
    ></dropdown>
  </div>
  <color-selector class="choice" [tinyMode]="true" [color]="brandingText.color || '#000000'" (changeColor)="brandingText.color = $event; changed.emit()"></color-selector>
</div>

`,
    styleUrls: ['./branding-text.scss'],
    standalone: true,
    imports: [TitleIconComponent, InputEditorComponent, CommonModule, DropdownComponent, ColorSelectorComponent, FindByIdPipe],
})


export class BrandingTextComponent {
  @Input() brandingText: HomePageTextBlock
  @Input() title: string = 'Text block'
  @Input() placeholder: string = 'Add text...'
  @Output() changed: EventEmitter<null> = new EventEmitter()

  DEFAULT_FONT_SIZE = DEFAULT_BRANDING_TEXT_SIZE
  fontSizeSelections = [6,8,10,12,14,16,18,20,22,24,26,28,30].map(n => ({ id: n, title: `${n} px`}))
  

}

